import React, { useState } from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { SlotGames } from "../../../../lib/data/SlotGames.data";
import { useNavigate } from "react-router-dom";
import GamesSearchModal from "../../../components/GamesSearchModal";

const Slots = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    { name: "All", key: "all" },
    { name: "NetEnt", key: "netenttab" },
    { name: "Red Tiger", key: "redtigertab" },
    { name: "Ezugi Slots", key: "ezugiSlots" },
    // { name: "Jili Games", key: "jiliGaming" },
  ];
  const [activeCategory, setActiveCategory] = useState("all");

  // **Get Games for Active Category**
  const filteredGames =
    activeCategory === "all"
      ? [
          ...Object.values(SlotGames.netenttab || []),
          ...Object.values(SlotGames.redtigertab || []),
          ...Object.values(SlotGames.jiliGaming || []),
          ...Object.values(SlotGames.ezugiSlots || []),
        ]
      : SlotGames[activeCategory]
      ? Object.values(SlotGames[activeCategory])
      : [];

  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>
      <main className="main">
        <div className="prvdr-game-page">
          <div className="games-heading">
            <h3>Slots</h3>
            <div className="d-none d-lg-block">
              <GamesSearchModal />
            </div>
          </div>

          {/* CATEGORY TABS */}
          <ul className="tabs">
            {categoriesTab.map((tab, index) => (
              <li
                key={index}
                onClick={() => {
                  if (tab?.redirectUrl) {
                    navigate(tab?.redirectUrl);
                  } else {
                    setActiveCategory(tab.key);
                  }
                }}
              >
                <a
                  href="#"
                  className={activeCategory === tab.key ? "active" : ""}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>

          {/* GAMES LIST */}
          <ul className="gamelisting">
            {filteredGames.length > 0 ? (
              filteredGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.redirectUrl}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Slots;
